import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { BellRing } from "lucide-react";

const OPTIONS = [
  ["bookings", "Bookings", "When a helper is booked for a visit"],
  ["completions", "Completions", "When a visit is marked complete"],
  ["safety", "Safety alerts", "If no “I'm safe” check-in within an hour (recommended)"],
];

export default function FamilyAlertPrefs({ prefs, token, onSaved }) {
  const [local, setLocal] = useState(prefs);
  const [busy, setBusy] = useState(false);

  const toggle = async (key) => {
    const next = { ...local, [key]: !local[key] };
    setLocal(next);
    setBusy(true);
    try {
      await axios.put(`${API}/family/prefs`, next, { headers: { "X-Family-Token": token } });
      toast.success("Alert preferences saved");
      onSaved?.(next);
    } catch { toast.error("Couldn't save. Please try again."); setLocal(local); }
    finally { setBusy(false); }
  };

  return (
    <section data-testid="family-alert-prefs" className="bg-white border border-[#E2D9CE] rounded-2xl p-6 mt-10">
      <div className="flex items-center gap-2 mb-1"><BellRing className="w-6 h-6 text-[#D96B43]" /><h2 className="text-2xl font-display font-bold text-slate-900">Which alerts would you like by email?</h2></div>
      <p className="text-slate-600 mb-4">Choose what we send you. You can change this any time.</p>
      <div className="space-y-3">
        {OPTIONS.map(([key, label, desc]) => (
          <div key={key} className="flex items-center justify-between gap-4 bg-[#FAF8F5] rounded-xl p-4">
            <div><p className="font-semibold text-slate-900">{label}</p><p className="text-sm text-slate-600">{desc}</p></div>
            <button type="button" role="switch" aria-checked={local[key]} disabled={busy} data-testid={`alert-pref-${key}`} onClick={() => toggle(key)}
              className={`relative w-16 h-9 rounded-full transition-colors shrink-0 ${local[key] ? "bg-[#2E7D6B]" : "bg-slate-300"}`}>
              <span className={`absolute top-1 w-7 h-7 rounded-full bg-white shadow transition-transform ${local[key] ? "translate-x-8" : "translate-x-1"}`} />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
